<template>
    <router-view></router-view>
</template>

<script>
import { router } from "./routers";
import { IPC_EVENT } from "./ipc_events";
import { store } from "./store";
import { VIEW_TYPE, WEB_BROWSER } from "./js/view_type";
import { BOOK_TYPE } from "./js/book_define/book_type";
import { settingStore } from "./js/store/settingStore";
export default {
    name: "Home",
    mounted() {
        //判斷當前裝置類型
        console.log(`當前打包類型 ${process.env.VUE_APP_VIEW_TYPE}`)
        store.nowView = process.env.VUE_APP_VIEW_TYPE;
        switch (store.nowView) {
            case VIEW_TYPE.PC:
            case VIEW_TYPE.MAC:
                window.ipcRenderer.receive(IPC_EVENT.READY, (msg) => {
                    if (msg == "Resource") {
                        store.onlyRead = true;
                        store.baseSize.width = store.verticalContainerWidth;
                        settingStore.isFixed = 0;
                        settingStore.isShowPenChange = 0;
                        store.nowBook = BOOK_TYPE.RESOURCE;
                        console.log("store.onlyRead = true;");
                    }
                    setTimeout(() => {
                        router.replace("App");
                    }, 100);
                });
                window.ipcRenderer.send(IPC_EVENT.READY);

                window.ipcRenderer.receive(IPC_EVENT.GET_FOLDER_PERMISSIONS, (folderPermissions) => {
                    store.folderPermissions = folderPermissions;
                });
                window.ipcRenderer.send(IPC_EVENT.GET_FOLDER_PERMISSIONS);
                break;
            case VIEW_TYPE.WEB:
                const userAgent = navigator.userAgent;
                if (/chrome|criOS/i.test(userAgent)) {
                    // 判斷使用chrome開啟
                    store.nowWebBrowser = WEB_BROWSER.CHROME;
                } else if (/iPad|iPhone|iPod|mac/i.test(userAgent) && /safari/i.test(userAgent)) {
                    // 判斷使用safari開啟
                    store.nowWebBrowser = WEB_BROWSER.SAFARI;
                }
                break;
            case VIEW_TYPE.ANDROID:
            case VIEW_TYPE.IOS:
                router.replace("App");
            default:
                break;
        }
    },
};
</script>

<style scoped></style>
